// Place endpoint
// https://www.go-ayutthaya.com/app/v1/api/places/popular
const api_version = '/v1/api'
//export const API_ROOT = `https://www.go-ayutthaya.com/app/index.php${api_version}`
export const API_ROOT = `https://go.ayutthaya.go.th/app/index.php${api_version}`

export const PLACE = '/places'
export const POPULAR = '/popular'
export const FOOD = '/restaurants'
export const OTOP = '/otops'
export const SHOPPING = '/shoppings'
export const NEWS = '/news'
export const HOTELS = '/hotels'
export const REQUEST = '/request'
export const AREAS = '/areas'
export const CATEGORY = '/categories'
export const PLACE_POPUPLAR = `/places${POPULAR}`
export const CHECK_LASTED = `/lasted`

export const api = {
  place: `${API_ROOT}${PLACE}`,
  placePopular: `${API_ROOT}${PLACE_POPUPLAR}`,
  food: `${API_ROOT}${FOOD}`,
  foodPopular: `${API_ROOT}${FOOD}${POPULAR}`,
  otop: `${API_ROOT}${OTOP}`,
  otopPopular: `${API_ROOT}${OTOP}${POPULAR}`,
  otopCheckoutCart: `${API_ROOT}${OTOP}${REQUEST}`,
  news: `${API_ROOT}${NEWS}`,
  newsPopular: `${API_ROOT}${NEWS}${POPULAR}`,
  hotels: `${API_ROOT}${HOTELS}`,
  hotelsPopular: `${API_ROOT}${HOTELS}${POPULAR}`,
  shopping: `${API_ROOT}${SHOPPING}`,
  shoppingPopular: `${API_ROOT}${SHOPPING}${POPULAR}`,
  areas: `${API_ROOT}${AREAS}`,
  category: `${API_ROOT}${CATEGORY}`,
  checkLasted: `${API_ROOT}${CHECK_LASTED}`,
}



// WEBPACK FOOTER //
// ./src/config/api.js